// features/workstations/tabs/knowledge.js
// ═══════════════════════════════════════════════════════════
// KNOWLEDGE TAB — three sections (Batch K1):
//   1. Feed       — daily intelligence with practitioner lens
//                   (V1: today's briefing as feed item;
//                    V1.5: Active Connection Layer)
//   2. Knowledge Base — searchable reference library
//                       (V1: curriculum.js seeded + user-saved)
//   3. Research   — curated breakthroughs sorted by relevance
//                   to user's setup (V1: manual curation)
// ═══════════════════════════════════════════════════════════

import { useState } from 'react';
import { SectionedTab } from '../shared';
import FeedSection from '../knowledge/feed-section';
import KBSection from '../knowledge/kb-section';
import ResearchSection from '../knowledge/research-section';

const SECTIONS = [
  { key: 'feed',     label: 'Feed' },
  { key: 'kb',       label: 'Knowledge Base' },
  { key: 'research', label: 'Research' },
];

export default function KnowledgeTab({ workstation, userId }) {
  const [section, setSection] = useState('feed');

  if (!workstation) {
    return (
      <div className="ws-tab-content">
        <div className="ws-placeholder">
          <div className="ws-placeholder-eyebrow">Loading</div>
          <div className="ws-placeholder-title">Knowledge</div>
          <div className="ws-placeholder-body">Preparing knowledge surface…</div>
        </div>
      </div>
    );
  }

  return (
    <div className="ws-tab-content">
      <SectionedTab
        eyebrow="Knowledge Zone"
        title={sectionTitle(section)}
        subtitle={sectionSubtitle(section)}
        sections={SECTIONS}
        activeKey={section}
        onSelect={setSection}
      >
        {section === 'feed' && <FeedSection workstation={workstation} />}
        {section === 'kb' && <KBSection workstation={workstation} userId={userId} />}
        {section === 'research' && <ResearchSection workstation={workstation} userId={userId} />}
      </SectionedTab>
    </div>
  );
}

function sectionTitle(s) {
  if (s === 'feed') return 'Domain Intelligence Feed';
  if (s === 'kb') return 'Knowledge Base';
  if (s === 'research') return 'Research & Breakthroughs';
  return 'Knowledge';
}
function sectionSubtitle(s) {
  if (s === 'feed') return 'Today\u2019s read on your domain, with the Practitioner Lens.';
  if (s === 'kb') return 'Concepts, terms, frameworks, your patterns — searchable reference.';
  if (s === 'research') return 'Curated developments. Sorted by relevance to your specific setup.';
  return null;
}
